module.exports = __webpack_public_path__ + "img/apple_mockup_iphone.2b0543f0.png";